import React from 'react'
import { Box, Container, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
import Logo from '../Logo'
import Navigation from '../Navigation'
import TouchWithUs from '../TouchWithUs'
import img from './../../../assets/footer/foot2.jpg'
import Social from './../Social'
import i18next from 'i18next'
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTheme } from '@emotion/react'
import { StyledBox, StyledLink } from './Ui'

const Footer1 = ({ data }) => {
    let lng = i18next.language
    const currentYear = new Date().getFullYear();

    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    return (
        <>
            <Box component={'footer'} sx={{
                position: 'relative',
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                padding: { md: '16px 0px', xs: 0 },
            }} >
                <div className="overlay"></div>
                <Container maxWidth={'90%'} sx={{ width: { md: '90%', xs: '100%' }, m: 'auto' }}>
                    <Grid container>
                        {isMobile && <>
                            <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                                <TouchWithUs >
                                    <Logo isMobile={isMobile} logo={data?.footerLogo} bio={data?.footerBio} />
                                    <Social data={data} />
                                </TouchWithUs>
                            </Grid>
                            <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                                <Navigation />
                            </Grid>
                        </>}
                        {isMobile || <>
                            <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                                <Navigation />
                            </Grid>
                            <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                                <TouchWithUs >
                                    <Logo isMobile={isMobile} logo={data?.footerLogo} bio={data?.footerBio} />
                                    <Social data={data} />
                                </TouchWithUs>
                            </Grid>
                        </>
                        }
                        <Grid item md={4} xs={12} sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                            <TouchWithUs >
                                <Typography variant='h6' color={'secondary.main'} mb={2} mt={2}>{data?.contact_us}</Typography> 
                                <StyledLink>
                                    <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <StyledBox>
                                            <EmailOutlinedIcon />
                                        </StyledBox>
                                        <Box>
                                            <Typography color={'primary.text'}
                                                sx={{ textTransform: 'capitalize' }} fontWeight={500}>{lng==='ar'?'البريد الإلكتروني':'Email'}</Typography>
                                            <Typography color={'primary.text'} fontWeight={500}>{data?.email}</Typography>
                                        </Box>
                                    </Box>
                                </StyledLink>
                                <StyledLink>
                                    <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <StyledBox>
                                            <HomeOutlinedIcon />
                                        </StyledBox>
                                        <Box>
                                            <Typography color={'primary.text'} fontWeight={500}
                                                sx={{ textTransform: 'capitalize' }}>{lng === 'ar' ? "العنوان":'Address'}</Typography>
                                            {data?.address1 && <Typography color={'primary.text'} fontWeight={500}>{data?.address1}</Typography>}
                                            {data?.address2 && <Typography color={'primary.text'} fontWeight={500}>{data?.address2}</Typography>}
                                        </Box>
                                    </Box>
                                </StyledLink>
                                <StyledLink>
                                    <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <StyledBox>
                                            <LocalPhoneOutlinedIcon />
                                        </StyledBox>
                                        <Box>
                                            <Typography color={'primary.text'} fontWeight={500}
                                                sx={{ textTransform: 'capitalize' }}>{lng === 'ar' ? "الهاتف":'Phone'}</Typography>
                                            {data?.tel1 && <a href={`tel:${data?.tel1}`} style={{ textDecoration: 'none' }}>
                                                <Typography color={'primary.text'} fontWeight={500}><bdi>{data?.tel1}</bdi></Typography>
                                            </a>}
                                            {data?.tel2 &&
                                                <a href={`tel:${data?.tel2}`} style={{ textDecoration: 'none' }}>
                                                    <Typography color={'primary.text'} fontWeight={500}><bdi>{data?.tel2}</bdi></Typography>
                                                </a>}
                                        </Box>
                                    </Box>
                                </StyledLink>
                            </TouchWithUs>
                        </Grid>
                    </Grid>
                </Container>
                <Divider sx={{ border: `1px solid #fff`, my: 2 }} />
                <Typography color='footer.link' variant={'body2'} fontWeight={200}
                    sx={{ position: 'relative', zIndex: 3, textAlign: 'center', my: 1 }} >
                    {lng === 'ar' ? `جميع الحقوق محفوظة ${currentYear}  أجرولاين `  :
                        ` Copyright © ${currentYear} Agroline.`}
                </Typography>
                {/* <Typography color='footer.link' variant={'body2'} fontWeight={200}
                    sx={{ position: 'relative', zIndex: 3, textAlign: 'center' }} >
                    Design And Development By <a href="https://revampbrands.com/" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noopener noreferrer">Revamp Brands</a>
                </Typography> */}
            </Box>
        </>
    )
}

export default Footer1